import { put, takeEvery } from 'redux-saga/effects';
import { SocketDisconnected as SocketDisconnectedAction } from '@signageos/actions/dist/Socket/socketActions';
import { SocketConnected as SocketConnectedAction, SocketConnectionFailed as SocketConnectionFailedAction } from '../Socket/socketActions';
import { createSystemLogAction } from './systemLogActionFactory';
import { DeviceAlive as DeviceAliveAction } from '../Offline/offlineActions';
import {
	DeviceAlive,
	SocketConnected,
	SocketConnectionFailed,
	SocketDisconnected,
} from '@signageos/common-types/dist/Device/SystemLogs/systemLogs';
import { withDependencies } from '../DI/dependencyInjection';

export function* commonSystemLogsSaga(socketName: string) {
	yield withDependencies(['featureFlags'], function* ({ featureFlags }) {
		if (featureFlags?.systemLogs ?? true) {
			yield takeEvery(SocketConnectedAction, function* (): IterableIterator<any> {
				yield put(
					createSystemLogAction({
						type: SocketConnected,
						socketName,
					} satisfies SocketConnected),
				);
			});
			yield takeEvery(SocketDisconnectedAction, function* (action: SocketDisconnectedAction): IterableIterator<any> {
				yield put(
					createSystemLogAction({
						type: SocketDisconnected,
						socketName,
						reason: action.reason,
						context: action.context,
					} satisfies SocketDisconnected),
				);
			});
			yield takeEvery(SocketConnectionFailedAction, function* (action: SocketConnectionFailedAction): IterableIterator<any> {
				yield put(
					createSystemLogAction({
						type: SocketConnectionFailed,
						errorMessage: action.errorMessage,
						socketName,
					} satisfies SocketConnectionFailed),
				);
			});
			yield takeEvery(DeviceAliveAction, function* (): IterableIterator<any> {
				yield put(
					createSystemLogAction({
						type: DeviceAlive,
					} satisfies DeviceAlive),
				);
			});
		}
	})();
}
